export enum benchmarkFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
}
